import styled from 'styled-components';
import { space, color, textAlign, fontSize, fontWeight, width, flex, display, alignItems } from 'styled-system';
import { ThemeInterface } from '../theme/ThemeInterface';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { theme } from '../theme';

type SpanProps = StyledSystemProps & {
  pointer?: boolean;
};

const Span = styled.span<SpanProps>`
  ${space};
  ${color};
  ${width};
  ${fontSize};
  ${textAlign};
  ${alignItems};
  ${fontWeight};
  ${flex};
  ${display};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
  &:hover {
    cursor: ${(props: ThemeInterface) => (props.pointer ? 'pointer' : 'default')};
  }
`;

export default Span;

Span.defaultProps = {
  fontSize: 0,
  color: theme.colors.charcoalGrey,
};



// WEBPACK FOOTER //
// ./src/typography/Span.ts